import { z } from "zod";
export const BlogCard = z.object({
  slug: z.string(),
  title: z.string(),
  tag: z.string().nullable(),
  author: z.string().nullable(),
  excerpt: z.string().nullable(),
  isFeatured: z.boolean(),
  publishedAt: z.string().nullable(),
  readTime: z.string().nullable(),
});
export const BlogPage = z.object({
  items: z.array(BlogCard),
  tags: z.array(z.string()),
  total: z.int(),
});
export const BlogArticle = BlogCard.extend({ id: z.uuid(), bodyHtml: z.string() });
export const FeedbackInput = z.strictObject({
  type: z.enum(["idea", "bug", "content", "other"]),
  message: z.string().trim().min(10).max(2000),
  contactEmail: z.email().max(254).nullable().default(null),
});
export const FeedbackItem = z.object({
  id: z.uuid(),
  type: z.string(),
  message: z.string(),
  status: z.enum(["new", "planned", "done", "rejected"]),
  votes: z.int(),
  voted: z.boolean(),
});
export const SearchResult = z.object({
  kind: z.enum(["test", "vocab", "note"]),
  id: z.string(),
  title: z.string(),
  description: z.string(),
  path: z.string(),
});
export const ShareInput = z.discriminatedUnion("kind", [
  z.strictObject({ kind: z.literal("score"), attemptId: z.uuid() }),
  z.strictObject({ kind: z.literal("day"), date: z.iso.date() }),
]);
export const SharePayload = z.discriminatedUnion("kind", [
  z.strictObject({
    kind: z.literal("score"),
    lc: z.int().min(0).max(495),
    rc: z.int().min(0).max(495),
    total: z.int().min(0).max(990),
  }),
  z.strictObject({
    kind: z.literal("day"),
    date: z.iso.date(),
    minutes: z.int().min(0),
    answered: z.int().min(0),
    correct: z.int().min(0),
  }),
]);
export const ShareLink = z.object({ token: z.string(), url: z.url() });

export const NewsletterEmail = z.email().max(254);
export const NewsletterToken = z.string().regex(/^[a-f0-9]{64}$/);
export const NewsletterEvent = z.object({ email: NewsletterEmail, token: NewsletterToken });
